<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="() => $refs.tableHeader.query()"
      @openEditFormDialog="openEditFormDialog"
      @openImageDialog="openImageDialog"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @query="getData"
      />
    </Main>

    <EditFormDialog
      :disabled="goodsDetailDialogParams.disabled"
      :visible.sync="goodsDetailDialogParams.visible"
      :title="goodsDetailDialogParams.title"
      :tcOrderGoodsCode="goodsDetailDialogParams.code"
      @reload="() => $refs.tableHeader.query()"
      ref="goodsDetailDialog"
    />
    <GoodsImagesDialog
      :visible.sync="goodsImagesDialogOptions.visible"
      :tcOrderGoodsCode="goodsImagesDialogOptions.code"
      :title="'查看TC订单产品图片信息'"
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header'
import EditFormDialog from '../edit-form/dialog.vue'
import GoodsImagesDialog from '../../../goods-images'
export default {
  components: { Main, Header, EditFormDialog, GoodsImagesDialog },
  props: {
    tcOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      goodsDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
      goodsImagesDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData(this.tcOrderCode)
  },
  methods: {
    getData(form) {
      if (!this.tcOrderCode) return
      this.loading = true
      this.$api
        .tcOrderGoodsListApi({ tcOrderCode: this.tcOrderCode, ...form })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit:
          this.$l('tc_order_goods_dialog_title_edit_info') ||
          '编辑TC订单产品信息',
        detail:
          this.$l('tc_order_goods_dialog_title_detail_info') ||
          'TC订单产品信息详情',
      }
      this.goodsDetailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    openImageDialog({ tcOrderGoodsCode }) {
      this.goodsImagesDialogOptions = { code: tcOrderGoodsCode, visible: true }
    },
  },
}
</script>
